<template>
    <div class="ah-page salary-edit-page">
        <div class="page-header bottom-margin">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1 v-if="!rawExistsData">新增人事薪資</h1>
                        <h1 v-if="rawExistsData">編輯人事薪資</h1>
                    </div>
                    <div class="actions"></div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <el-form :model="localForm" ref="form" size="small" label-position="right">
                <div class="ah-panel" style="margin-bottom: 10px">
                    <div class="panel-header small gray">
                        <div class="panel-title">薪資歸屬月份：{{ localForm.year }} / {{ localForm.month }}</div>
                        <div class="panel-action">
                            <el-button v-if="$route.params.year && !isQR()" size="small" @click="onDelete" icon="el-icon-delete">刪除</el-button>
                        </div>
                    </div>
                    <el-alert type="warning" :closable="false" v-if="isExists"
                        >已有該月資料：
                        <el-button type="text" @click="onOpenExistsData">檢視 {{ localForm.year }} / {{ localForm.month }} 人事薪資</el-button>
                    </el-alert>
                    <div class="ah-statistics-bar totals">
                        <div
                            :class="{
                                item: true,
                                highlight: isHighlightSalaryTotal,
                                blur: isHighlightRealPay,
                            }"
                            style="width: 50%"
                            @mouseover="isHighlightSalaryTotal = true"
                            @mouseleave="isHighlightSalaryTotal = false"
                        >
                            <div class="inner">
                                <div class="label">人事薪資總額<ah-tip>薪資總計 + 獎金績效 + 人事費用</ah-tip></div>
                                <div class="value">
                                    <Money :v="total_salary + total_bonus + total_fee" />
                                </div>
                            </div>
                        </div>
                        <div
                            :class="{
                                item: true,
                                highlight: isHighlightRealPay,
                                blur: isHighlightSalaryTotal,
                            }"
                            style="width: 50%"
                            @mouseover="isHighlightRealPay = true"
                            @mouseleave="isHighlightRealPay = false"
                        >
                            <div class="inner">
                                <div class="label">實付金額<ah-tip>薪資總計 + 獎金績效 - 代扣合計</ah-tip></div>
                                <div class="value">
                                    <Money :v="total_pay" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="ah-statistics-bar">
                        <div
                            :class="{
                                item: true,
                                highlight: isHighlightSalaryTotal,
                                blur: isHighlightRealPay,
                            }"
                            style="width: 20%"
                        >
                            <div class="inner">
                                <div class="label">人事費用<ah-tip>公司負擔(退休金 + 勞保費 + 健保費 + 二代健保)</ah-tip></div>
                                <div class="value">
                                    <Money :v="total_fee" />
                                </div>
                            </div>
                        </div>
                        <div
                            :class="{
                                item: true,
                                highlight: isHighlightSalaryTotal || isHighlightRealPay,
                            }"
                            style="width: 20%"
                        >
                            <div
                                :class="{
                                    'calc-symbol': true,
                                    add: true,
                                    show: isHighlightSalaryTotal,
                                }"
                            ></div>
                            <div class="inner">
                                <div class="label">薪資總計<ah-tip>固定薪資總計 + 非固定薪資總計</ah-tip></div>
                                <div class="value">
                                    <Money :v="total_salary" />
                                </div>
                            </div>
                        </div>
                        <div
                            :class="{
                                item: true,
                                highlight: isHighlightSalaryTotal || isHighlightRealPay,
                            }"
                            style="width: 20%"
                        >
                            <div
                                :class="{
                                    'calc-symbol': true,
                                    add: true,
                                    show: isHighlightSalaryTotal || isHighlightRealPay,
                                }"
                            ></div>
                            <div class="inner">
                                <div class="label">獎金績效<ah-tip>獎金 + 績效</ah-tip></div>
                                <div class="value">
                                    <Money :v="total_bonus" />
                                </div>
                            </div>
                        </div>
                        <div
                            :class="{
                                item: true,
                                highlight: isHighlightRealPay,
                                blur: isHighlightSalaryTotal,
                            }"
                            style="width: 20%"
                        >
                            <div
                                :class="{
                                    'calc-symbol': true,
                                    divide: true,
                                    show: isHighlightRealPay,
                                }"
                            ></div>
                            <div class="inner">
                                <div class="label">代扣合計<ah-tip>代扣款項合計 + 其他代扣</ah-tip></div>
                                <div class="value">
                                    <Money :v="total_withholding" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-show="$route.params.year">
                    <span class="" v-if="rawExistsData" style="display: block; color: #888; font-size: 9pt; font-weight: normal; padding-top: 0px; margin-bottom: 20px; text-align: right">
                        <div>資料建立：{{ rawExistsData.crT_USR }} ({{ rawExistsData.crT_DAT | dateFormater("YYYY-MM-dd") }})</div>
                        <div v-if="rawExistsData.upD_USR">最後編輯：{{ rawExistsData.upD_USR }} ({{ rawExistsData.upD_DAT | dateFormater("YYYY-MM-dd") }})</div>
                    </span>
                </div>
                <div class="ah-panel" id="salary-edit-table" style="min-height: 200px">
                    <div class="panel-header small gray">
                        <div class="panel-title">
                            <el-form-item prop="nam" label="薪資歸屬月份：" label-position="left" style="margin-bottom: 0">
                                <el-select v-model="localForm.year" placeholder="請選擇" style="max-width: 130px; margin-right: 5px" :disabled="!!$route.params.year" @change="handleYearChange">
                                    <el-option v-for="item in yearList" :label="item" :value="item" :key="item"></el-option>
                                </el-select>
                                <el-select v-model="localForm.month" placeholder="請選擇" style="max-width: 130px" :disabled="!!$route.params.year" @change="handleMonthChange">
                                    <el-option v-for="item in monthOptions" :label="item.value" :value="item.key" :disabled="!!item.disabled" :key="item.key"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="edit-tab-bar">
                        <div></div>
                        <el-radio-group v-model="currTab">
                            <el-radio-button label="1">固定薪資</el-radio-button>
                            <el-radio-button label="2">非固定薪資</el-radio-button>
                            <el-radio-button label="3">績效、獎金</el-radio-button>
                            <!-- <el-radio-button label="4">人事費用</el-radio-button> -->
                        </el-radio-group>
                        <el-dropdown v-if="!isQR()" split-button size="small" @click="onImportLastMonth" @command="onImportCommand">
                            複製上個月：{{ currTabName }}
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="all">複製全部</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <!-- <el-button size="small" @click="copyLastMonth">複製上個月：{{ currTabName }}</el-button> -->
                    </div>
                    <div v-if="isFormLoaded" class="panel-body">
                        <!-- 固定薪資 -->
                        <FixedTab
                            v-show="currTab == '1'"
                            :data="fixedData"
                            :rules="rules"
                            :updateAmts="updateAmts"
                            :onChangeDate="onChangeDate"
                            :onChangeBank="onChangeBank"
                            :onMoneyInputBlur="onMoneyInputBlur"
                            @input="onInput"
                        />
                        <!-- 非固定薪資 -->
                        <NonFixedTab v-show="currTab == '2'" :data="nonFixedData" :rules="rules" :updateAmts="updateAmts" :onChangeDate="onChangeDate" :onChangeBank="onChangeBank" @input="onInput" />
                        <!-- 績效獎金 -->
                        <BonusTab v-show="currTab == '3'" :data="bonusData" :rules="rules" :updateAmts="updateAmts" :onChangeDate="onChangeDate" @input="onInput" />
                    </div>
                </div>
                <div class="ah-panel" style="margin-bottom: 10px">
                    <div class="panel-body">
                        <h3 class="section-title" style="display: flex; align-items: center; justify-content: space-between; align-items: center">
                            <span
                                >人事費用
                                <span style="color: #999; font-size: 10pt; font-weight: normal; margin-left: 10px">歸屬年月：{{ localForm.year }} / {{ localForm.month }}</span>
                            </span>
                            <el-button size="small" @click="copyLastMonthPersonnel">複製上個月：人事費用</el-button>
                        </h3>
                        <!-- 人事費用 -->
                        <PersonnelTab :data="personnelData" :rules="rules" :updateAmts="updateAmts" :onChangeDate="onChangeDate" :onChangeBank="onChangeBank" @input="onInput" />
                    </div>
                </div>
            </el-form>
        </div>
        <div class="ah-container" style="margin-top: 25px">
            <div class="ah-panel">
                <div class="panel-body">
                    <div class="bottom-summary">
                        <div class="item">
                            <div class="label">人事薪資總額<ah-tip>薪資總計 + 獎金績效 + 人事費用</ah-tip></div>
                            <div class="value">
                                <Money :v="total_salary + total_bonus + total_fee" />
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">實付金額<ah-tip>薪資總計 + 獎金績效 - 代扣合計</ah-tip></div>
                            <div class="value">
                                <Money :v="total_pay" />
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">人事費用<ah-tip>公司負擔(退休金 + 勞保費 + 健保費 + 二代健保)</ah-tip></div>
                            <div class="value">
                                <Money :v="total_fee" />
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">薪資總計<ah-tip>固定薪資總計 + 非固定薪資總計</ah-tip></div>
                            <div class="value">
                                <Money :v="total_salary" />
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">獎金績效<ah-tip>獎金 + 績效</ah-tip></div>
                            <div class="value">
                                <Money :v="total_bonus" />
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">代扣合計<ah-tip>代扣款項合計 + 其他代扣</ah-tip></div>
                            <div class="value">
                                <Money :v="total_withholding" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <center>
            <el-button
                type=""
                class=""
                icon="el-icon-back"
                @click="
                    $router.push({
                        name: 'salary',
                        query: { year: localForm.year },
                    })
                "
                >回列表</el-button
            >
            <el-button v-if="!isQR()" type="primary" class="primary-action" @click="onSubmit" :loading="isSubmitting" icon="el-icon-check">{{ $route.params.year ? "儲存" : "新增" }}</el-button>
        </center>
    </div>
</template>
<script>
import _ from 'lodash';
import ahTip from '@/components/ui/ahTip.vue';
import moment from 'moment';
import FixedTab from './FixedTab.vue';
import NonFixedTab from './NonFixedTab.vue';
import BonusTab from './BonusTab.vue';
import PersonnelTab from './PersonnelTab.vue';

export default {
    components: {
        ahTip,
        FixedTab,
        NonFixedTab,
        BonusTab,
        PersonnelTab,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        inputObject: {
            type: Object,
            default: null,
        },
    },

    // LOB      = 代扣勞保
    // GEN      = 代扣健保
    // GEN2     = 代扣二代健保
    // TAX      = 代扣稅款
    // REM_FEE  = 匯費
    // FEE_ELS  = 其他代扣
    // ELS      = 代扣獎金稅款
    // FEE_REST = 退休金
    // FEE_LOB  = 勞保費用
    // FEE_GEN  = 健保費用
    // FEE_GEN2 = 二代健保費用

    data() {
        // 表單驗證 日期
        // eslint-disable-next-line consistent-return
        const validatePayDayInput = (rule, value, callback) => {
            // 找出欄位索引
            const reg = /forms\[(\d)\].items\[(\d)\].*?/g;
            const matches = reg.exec(rule.field);
            const f_idx = parseInt(matches[1], 10);
            const i_idx = parseInt(matches[2], 10);

            // 檢查是否有金額
            const { amt } = this.localForm.forms[f_idx].items[i_idx];
            if (amt && !value) {
                return callback(new Error('請輸入日期'));
            }
            callback();
        };

        // 表單驗證 銀行
        // eslint-disable-next-line consistent-return
        const validateBankInput = (rule, value, callback) => {
            // 找出欄位索引
            const reg = /forms\[(\d)\].items\[(\d)\].*?/g;
            const matches = reg.exec(rule.field);
            const f_idx = parseInt(matches[1], 10);
            const i_idx = parseInt(matches[2], 10);

            // 檢查是否有金額
            const { amt } = this.localForm.forms[f_idx].items[i_idx];
            if (amt && !value) {
                return callback(new Error('請選擇銀行帳號'));
            }
            callback();
        };

        const validatePersonnelPamtInput = (rule, value, callback) => {
            console.log('A');
            // 找出欄位索引
            const reg = /forms\[(\d)\].items\[(\d)\].*?/g;
            const matches = reg.exec(rule.field);
            const tabIdx = parseInt(matches[1], 10);
            const rowIdx = parseInt(matches[2], 10);

            // 只檢查人事薪資的勞保費、健保費，繳款單金額應 >= 員工自付金額（公司負擔才不會是負數）
            if (tabIdx === 3 && (rowIdx === 1 || rowIdx === 2)) {
                // 檢查公司負擔是否為負數
                const { amt } = this.localForm.forms[tabIdx].items[rowIdx];
                if (amt < 0) {
                    return callback(new Error('不可小於員工自付額'));
                }
            }
            callback();
            return true;
        };

        return {
            isExists: false,
            isSubmitting: false,
            isFormLoaded: false,
            isHighlightSalaryTotal: false,
            isHighlightRealPay: false,
            rawExistsData: null,
            loading: null,
            currTab: '1',
            localForm: {
                year: null,
                month: null,
                forms: [
                    // 固定薪資
                    {
                        name: 'fixed',
                        mem: '',
                        headcount: 0,
                        items: [
                            {
                                id: 'totaL_AMT',
                                type: '月薪資總計',
                                tip: '月薪資 － 請假扣薪',
                                iteM_NO: '',
                                iteM_SNO: 'totaL_AMT',
                                amt: null,
                                paY_DAT: null,
                                bnK_SNO: null,
                                fee: null,
                            },
                            {
                                id: 'TAX',
                                type: '代扣稅款',
                                tip: '薪資稅款',
                                iteM_NO: 'TAX',
                                iteM_SNO: null,
                                amt: null,
                                paY_DAT: null,
                                bnK_SNO: null,
                                fee: null,
                                negative: true,
                            },
                            {
                                id: 'LOB',
                                type: '代扣勞保',
                                tip: '代扣員工自付勞保費',
                                iteM_NO: 'LOB',
                                iteM_SNO: null,
                                amt: null,
                                paY_DAT: null,
                                bnK_SNO: null,
                                fee: null,
                                negative: true,
                            },
                            {
                                id: 'GEN',
                                type: '代扣健保',
                                tip: '代扣員工自付健保費',
                                iteM_NO: 'GEN',
                                iteM_SNO: null,
                                amt: null,
                                paY_DAT: null,
                                bnK_SNO: null,
                                fee: null,
                                negative: true,
                            },
                            // {
                            //     id: 'GEN2',
                            //     type: '代扣二代健保',
                            //     tip: '',
                            //     iteM_NO: 'GEN2',
                            //     iteM_SNO: null,
                            //     amt: null,
                            //     paY_DAT: null,
                            //     bnK_SNO: null,
                            //     fee: null,
                            //     hidden: true,
                            //     negative: true,
                            // },
                            {
                                id: 'FEE_ELS',
                                type: '其他代扣',
                                tip: '例如：負責人自繳退休金、公司代扣員工自提退休金... 請於備註中註明。',
                                iteM_NO: 'FEE_ELS',
                                iteM_SNO: null,
                                amt: null,
                                paY_DAT: null,
                                bnK_SNO: null,
                                fee: null,
                                negative: true,
                            },
                            {
                                id: 'actualAmt',
                                type: '實付薪資',
                                tip: '月薪資總計 - (代扣稅款 + 代扣勞保 + 代扣健保 + 其他代扣)',
                                iteM_NO: '',
                                iteM_SNO: 'amt',
                                amt: null,
                                paY_DAT: null,
                                bnK_SNO: null,
                                fee: null,
                            },
                        ],
                    },

                    // 非固定薪資
                    {
                        name: 'non-fixed',
                        mem: '',
                        headcount: 0,
                        items: [
                            {
                                id: 'totaL_AMT',
                                type: '薪資總計',
                                tip: '',
                                iteM_NO: '',
                                iteM_SNO: 'totaL_AMT',
                                amt: null,
                                paY_DAT: null,
                                bnK_SNO: null,
                                fee: null,
                            },
                            {
                                id: 'TAX',
                                type: '代扣稅款',
                                tip: '薪資稅款',
                                iteM_NO: 'TAX',
                                iteM_SNO: null,
                                amt: null,
                                paY_DAT: null,
                                bnK_SNO: null,
                                fee: null,
                                negative: true,
                            },
                            {
                                id: 'LOB',
                                type: '代扣勞保',
                                tip: '',
                                iteM_NO: 'LOB',
                                iteM_SNO: null,
                                amt: null,
                                paY_DAT: null,
                                bnK_SNO: null,
                                fee: null,
                                negative: true,
                            },
                            {
                                id: 'GEN',
                                type: '代扣健保',
                                tip: '',
                                iteM_NO: 'GEN',
                                iteM_SNO: null,
                                amt: null,
                                paY_DAT: null,
                                bnK_SNO: null,
                                fee: null,
                                negative: true,
                            },
                            {
                                id: 'GEN2',
                                type: '代扣二代健保',
                                tip: '',
                                iteM_NO: 'GEN2',
                                iteM_SNO: null,
                                amt: null,
                                paY_DAT: null,
                                bnK_SNO: null,
                                fee: null,
                                negative: true,
                            },
                            {
                                id: 'FEE_ELS',
                                type: '其他代扣',
                                tip: '',
                                iteM_NO: 'FEE_ELS',
                                iteM_SNO: null,
                                amt: null,
                                paY_DAT: null,
                                bnK_SNO: null,
                                fee: null,
                                negative: true,
                            },
                            {
                                id: 'actualAmt',
                                type: '實付薪資',
                                tip: '月薪資總計 - (代扣稅款 + 代扣勞保 + 代扣健保 + 代扣二代健保 + 其他代扣)',
                                iteM_NO: '',
                                iteM_SNO: 'amt',
                                amt: null,
                                paY_DAT: null,
                                bnK_SNO: null,
                                fee: null,
                            },
                        ],
                    },

                    // 獎金績效
                    {
                        name: 'bonus',
                        mem: '',
                        headcount: 0,
                        items: [
                            {
                                id: 'totaL_AMT',
                                type: '獎金',
                                tip: '',
                                iteM_NO: '',
                                iteM_SNO: 'totaL_AMT',
                                amt: null,
                                paY_DAT: null,
                                bnK_SNO: null,
                                fee: null,
                            },
                            {
                                id: 'totaL_AMT2',
                                type: '績效',
                                tip: '',
                                iteM_NO: '',
                                iteM_SNO: 'totaL_AMT2',
                                amt: null,
                                paY_DAT: null,
                                bnK_SNO: null,
                                fee: null,
                            },
                            {
                                id: 'ELS',
                                type: '代扣獎金稅款',
                                tip: '',
                                iteM_NO: 'ELS',
                                iteM_SNO: 87,
                                amt: null,
                                paY_DAT: null,
                                bnK_SNO: null,
                                fee: null,
                                negative: true,
                            },
                            {
                                id: 'GEN2',
                                type: '代扣二代健保',
                                tip: '',
                                iteM_NO: 'GEN2',
                                iteM_SNO: null,
                                amt: null,
                                paY_DAT: null,
                                bnK_SNO: null,
                                fee: null,
                                negative: true,
                            },
                            {
                                id: 'actualAmt',
                                type: '實付金額',
                                tip: '獎金 + 績效 - (代扣稅款 + 代扣二代健保)',
                                iteM_NO: '',
                                iteM_SNO: 'amt',
                                amt: null,
                                paY_DAT: null,
                                bnK_SNO: null,
                                fee: null,
                            },
                        ],
                    },

                    // 人事費用
                    {
                        name: 'personnel',
                        mem: '',
                        headcount: 0,
                        items: [
                            {
                                id: 'FEE_REST',
                                type: '退休金',
                                tip: '',
                                iteM_NO: 'FEE_REST',
                                iteM_SNO: null,
                                pamt: null,
                                amt: null,
                                paY_DAT: null,
                                bnK_SNO: null,
                                fee: null,
                                headcount: 0,
                                payroll: 0,
                            },
                            {
                                id: 'FEE_LOB',
                                type: '勞保費',
                                tip: '',
                                iteM_NO: 'FEE_LOB',
                                iteM_SNO: null,
                                pamt: null,
                                amt: null,
                                empSelfPay: null,
                                paY_DAT: null,
                                bnK_SNO: null,
                                fee: null,
                                headcount: 0,
                                payroll: 0,
                            },
                            {
                                id: 'FEE_GEN',
                                type: '健保費',
                                tip: '',
                                iteM_NO: 'FEE_GEN',
                                iteM_SNO: null,
                                pamt: null,
                                amt: null,
                                empSelfPay: null,
                                paY_DAT: null,
                                bnK_SNO: null,
                                fee: null,
                                headcount: 0,
                                payroll: 0,
                            },
                            {
                                id: 'FEE_GEN2',
                                type: '二代健保（健保補充保費）',
                                tip: '',
                                iteM_NO: 'FEE_GEN2',
                                iteM_SNO: null,
                                pamt: null,
                                amt: null,
                                paY_DAT: null,
                                bnK_SNO: null,
                                fee: null,
                                headcount: 0,
                            },
                        ],
                    },
                ],
            },
            rules: {
                paY_DAT: [{ validator: validatePayDayInput, trigger: 'change' }],
                bnK_SNO: [{ validator: validateBankInput, trigger: 'change' }],
                headcount: [{ required: true, message: '請輸入人數', trigger: 'blur' }],
                personnel_pamt: [{ validator: validatePersonnelPamtInput, trigger: 'blur' }],
            },
            activeName: 1,
            yearList: [],
            withholdingOptions: [],
            total_salary: 0, // 薪資總計
            total_bonus: 0, // 獎金績效
            total_withholding: 0, // 代扣合計
            total_pay: 0, // 實付金額
            total_fee: 0, // 人事費用

            lastPersonnelInfo: {
                laborPayDat: null,
                laborBnk: null,
                genPayDat: null,
                genBnk: null,
            },
        };
    },

    computed: {
        currTabName() {
            switch (this.currTab) {
            case '1':
                return '固定薪資';
            case '2':
                return '非固定薪資';
            case '3':
                return '績效、獎金';
            case '4':
                return '人事費用';
            default:
                return '';
            }
        },
        monthOptions() {
            const thisYear = new Date().getFullYear();
            const thisMonth = new Date().getMonth() + 1;

            const monthes = [];
            for (let m = 1; m <= 12; m += 1) {
                monthes.push({
                    key: m,
                    value: `${m}月`,
                    disabled: this.localForm.year === thisYear && m > thisMonth,
                });
            }
            return monthes;
        },
        fixedData() {
            return _.find(this.localForm.forms, ['name', 'fixed']);
        },
        nonFixedData() {
            return _.find(this.localForm.forms, ['name', 'non-fixed']);
        },
        bonusData() {
            return _.find(this.localForm.forms, ['name', 'bonus']);
        },
        personnelData() {
            return _.find(this.localForm.forms, ['name', 'personnel']);
        },
        companyInfo() {
            return this.$store.getters['menu/companyInfo'];
        },
    },
    async mounted() {
        const { year } = this.$route.params;
        const { month } = this.$route.params;

        const loading = this.$loading({
            lock: true,
            text: '載入中',
            spinner: 'el-icon-loading',
            target: '#salary-edit-table',
        });
        try {
            // 載入下拉年份
            await this.fetchYearList();

            // 載入表單項目
            await this.fetchWithholdingOptions();
            // 將項目 sno 更新至表單資料
            this.mapItemSnoToLocalForm();

            if (year && month) {
                // 編輯模式（載入該月薪資資料）
                await this.fetchSalaryData(year, month, null);
                this.isFormLoaded = true;
                await this.fetchLastPersonnelInfo(year, month);
            } else {
                // 新增模式
                this.localForm.year = new Date().getFullYear(); // 預設日期
                this.localForm.month = new Date().getMonth() + 1; // 預設日期
                this.isFormLoaded = true;
                this.checkDataExists();
            }
        } finally {
            loading.close();
        }
    },
    methods: {
        onInput($event) {
            this[$event.name][$event.field] = $event.value;
        },
        handleYearChange() {
            this.checkDataExists();
        },
        handleMonthChange() {
            this.checkDataExists();
        },
        async checkDataExists() {
            // 確認是新增模式
            if (this.$route.params.year == null) {
                const { year } = this.localForm;
                const { month } = this.localForm;
                try {
                    await this.fetchLastPersonnelInfo(year, month);
                    await this.$api_silent({
                        url: `/SalaryManagementPage/GetSalaryForm?Year=${year}&Month=${month}`,
                        method: 'GET',
                    });
                    this.isExists = true;
                } catch (e) {
                    this.isExists = false;
                }
            }
        },

        onOpenExistsData() {
            this.$router.push({
                name: 'salary-edit',
                params: {
                    year: this.localForm.year,
                    month: this.localForm.month,
                },
            });

            // refresh
            this.$loading({
                lock: true,
                text: '載入中',
                spinner: 'el-icon-loading',
            });

            setTimeout(() => {
                this.$router.go();
            }, 1);
        },

        // 將 sno 輸入到 localForm (必須 withholdingOptions 已載入)
        mapItemSnoToLocalForm() {
            const form = this.localForm.forms;
            for (let i = 0; i < form.length; i += 1) {
                const { items } = form[i];
                for (let j = 0; j < items.length; j += 1) {
                    const item = items[j];
                    const option = this.withholdingOptions.find((x) => x.iteM_NO === item.iteM_NO);
                    if (option) {
                        item.iteM_SNO = option.sno;
                    }
                }
            }
        },

        // 載入已有資料的年份
        async fetchYearList() {
            const resp = await this.$api({
                url: 'SalaryManagementPage/GetQueryYearOptions',
                method: 'GET',
            });
            // 加入上一年
            const thisYear = new Date().getFullYear();
            const lastYear = thisYear - 1;

            if (!resp.data.options.find((x) => x.year === 2020)) {
                resp.data.options.push({ year: lastYear });
                resp.data.options.sort();
            }

            // 更新資料
            const yearList = [];
            const INIT_YEAR = 2020;

            for (let i = INIT_YEAR; i <= thisYear; i += 1) yearList.push(i);

            this.yearList = yearList.reverse();
        },

        async fetchLastPersonnelInfo(year, month) {
            try {
                let yearNum = Number(year);
                let monthNum = Number(month) - 1;
                if (monthNum === 0) {
                    monthNum = 12;
                    yearNum -= 1;
                }

                const resp = await this.$api_silent({
                    url: `/SalaryManagementPage/GetSalaryForm?Year=${yearNum}&Month=${monthNum}`,
                    method: 'GET',
                });

                const personnelVariableStatements = resp.data.items[3].variableStatements;

                const personnelLOBItemSno = _.find(this.personnelData.items, ['id', 'FEE_LOB']).iteM_SNO;
                const personnelGENItemSno = _.find(this.personnelData.items, ['id', 'FEE_GEN']).iteM_SNO;
                const personnelGEN2ItemSno = _.find(this.personnelData.items, ['id', 'FEE_GEN2']).iteM_SNO;
                const personnelRESTItemSno = _.find(this.personnelData.items, ['id', 'FEE_REST']).iteM_SNO;

                const personnelLOB = _.find(personnelVariableStatements, ['iteM_SNO', personnelLOBItemSno]);
                const personnelGEN = _.find(personnelVariableStatements, ['iteM_SNO', personnelGENItemSno]);
                const personnelGEN2 = _.find(personnelVariableStatements, ['iteM_SNO', personnelGEN2ItemSno]);
                const personnelREST = _.find(personnelVariableStatements, ['iteM_SNO', personnelRESTItemSno]);

                this.lastPersonnelInfo.laborPamt = personnelLOB.pamt;
                this.lastPersonnelInfo.laborPayDat = personnelLOB.paY_DAT;
                this.lastPersonnelInfo.laborBnk = personnelLOB.bnK_SNO;
                this.lastPersonnelInfo.laborHeadCount = personnelLOB.headcount;
                this.lastPersonnelInfo.laborPayRoll = personnelLOB.payroll;

                this.lastPersonnelInfo.genPamt = personnelGEN.pamt;
                this.lastPersonnelInfo.genPayDat = personnelGEN.paY_DAT;
                this.lastPersonnelInfo.genBnk = personnelGEN.bnK_SNO;
                this.lastPersonnelInfo.genHeadCount = personnelGEN.headcount;
                this.lastPersonnelInfo.genPayRoll = personnelGEN.payroll;

                this.lastPersonnelInfo.gen2Pamt = personnelGEN2.pamt;
                this.lastPersonnelInfo.gen2PayDat = personnelGEN2.paY_DAT;
                this.lastPersonnelInfo.gen2Bnk = personnelGEN2.bnK_SNO;
                this.lastPersonnelInfo.gen2HeadCount = personnelGEN2.headcount;

                this.lastPersonnelInfo.restPamt = personnelREST.pamt;
                this.lastPersonnelInfo.restPayDat = personnelREST.paY_DAT;
                this.lastPersonnelInfo.restBnk = personnelREST.bnK_SNO;
                this.lastPersonnelInfo.restHeadCount = personnelREST.headcount;
                this.lastPersonnelInfo.restPayRoll = personnelREST.payroll;
            } catch (e) {
                console.log(e);
                this.lastPersonnelInfo = {
                    laborPamt: 0,
                    laborPayDat: null,
                    laborBnk: null,
                    laborHeadCount: 0,
                    laborPayRoll: 0,
                    genPamt: 0,
                    genPayDat: null,
                    genBnk: null,
                    genHeadCount: 0,
                    genPayRoll: 0,
                    gen2Pamt: 0,
                    gen2PayDat: null,
                    gen2Bnk: null,
                    gen2HeadCount: 0,
                    restPamt: 0,
                    restBnk: null,
                    restPayDat: null,
                    restHeadCount: 0,
                    restPayRoll: 0,
                };
            }
        },

        // 載入已存在的薪資
        async fetchSalaryData(year, month, copyLastMonthTab) {
            const resp = await this.$api({
                url: `/SalaryManagementPage/GetSalaryForm?Year=${year}&Month=${month}`,
                method: 'GET',
            });

            this.apiFormToLocalForm(resp.data, copyLastMonthTab);
            if (!copyLastMonthTab) this.rawExistsData = resp.data;
            console.log(`Get Salary: ${year}/${month}`, resp.data);
        },

        // 取得代扣項目列表(sno)
        async fetchWithholdingOptions() {
            const resp = await this.$api({
                url: 'SalaryManagementPage/GetWithholdingOptions',
                method: 'GET',
            });
            this.status = 'success';
            console.log('WithholdingOptions', resp);
            this.withholdingOptions = resp.data.options;
        },

        // 將目前表單轉換為 api 接收格式（送出表單時轉換）
        localFormToApiForm(localForm) {
            const form = {
                typ: 0,
                year: localForm.year,
                month: localForm.month,
                items: [
                    {
                        typ: 1,
                        title: '固定薪資',
                        amt: this.fixedData.items[5].amt, // 實付薪資
                        totaL_AMT: this.fixedData.items[0].amt, // 月薪資總計
                        paY_DAT: this.fixedData.items[5].paY_DAT,
                        bnK_SNO: this.fixedData.items[5].bnK_SNO,
                        PAY_WAY: this.fixedData.items[5].bnK_SNO < 0 ? 1 : 2,
                        variableStatements: _.chain(this.fixedData.items)
                            .filter((item) => Number.isInteger(item.iteM_SNO))
                            .map((o) => ({ ...o, PAY_WAY: o.bnK_SNO < 0 ? 1 : 2 }))
                            .value(),
                        mem: this.fixedData.mem,
                        headcount: this.fixedData.headcount,
                    },
                    {
                        typ: 2,
                        title: '非固定薪資',
                        amt: this.nonFixedData.items[6].amt, // 實付薪資
                        totaL_AMT: this.nonFixedData.items[0].amt, // 月薪資總計
                        paY_DAT: this.nonFixedData.items[6].paY_DAT,
                        bnK_SNO: this.nonFixedData.items[6].bnK_SNO,
                        PAY_WAY: this.nonFixedData.items[6].bnK_SNO < 0 ? 1 : 2,
                        variableStatements: _.chain(this.nonFixedData.items)
                            .filter((item) => Number.isInteger(item.iteM_SNO))
                            .map((o) => ({ ...o, PAY_WAY: o.bnK_SNO < 0 ? 1 : 2 }))
                            .value(),
                        mem: this.nonFixedData.mem,
                        headcount: this.nonFixedData.headcount,
                    },
                    {
                        typ: 3,
                        title: '績效、年終獎金',
                        amt: this.bonusData.items[4].amt, // 實付薪資,
                        totaL_AMT: this.bonusData.items[0].amt, // 獎金
                        totaL_AMT2: this.bonusData.items[1].amt, // 績效
                        paY_DAT: this.bonusData.items[4].paY_DAT,
                        bnK_SNO: this.bonusData.items[4].bnK_SNO,
                        PAY_WAY: this.bonusData.items[4].bnK_SNO < 0 ? 1 : 2,
                        variableStatements: _.chain(this.bonusData.items)
                            .filter((item) => Number.isInteger(item.iteM_SNO))
                            .map((o) => ({ ...o, PAY_WAY: o.bnK_SNO < 0 ? 1 : 2 }))
                            .value(),
                        mem: this.bonusData.mem,
                        headcount: this.bonusData.headcount,
                    },
                    {
                        typ: 4,
                        title: '人事費用',
                        amt: 0,
                        paY_DAT: null,
                        bnK_SNO: null,
                        PAY_WAY: 2,
                        variableStatements: _.chain(this.personnelData.items)
                            .filter((item) => Number.isInteger(item.iteM_SNO))
                            .map((o) => ({ ...o, PAY_WAY: o.bnK_SNO < 0 ? 1 : 2 }))
                            .value(),
                        mem: this.personnelData.mem,
                        headcount: this.personnelData.headcount,
                    },
                ],
            };

            // 匯費，加入匯費資料（銀行、日期使用與實付一樣資料）
            // 取得匯費 sno
            const REM_FEE_sno = this.findItemSnoByNo('REM_FEE');

            // 固定薪資 匯費
            if (this.fixedData.items[5].fee) {
                form.items[0].variableStatements.push({
                    iteM_SNO: REM_FEE_sno,
                    amt: this.fixedData.items[5].fee,
                    paY_DAT: this.fixedData.items[5].paY_DAT,
                    bnK_SNO: this.fixedData.items[5].bnK_SNO,
                    PAY_WAY: this.fixedData.items[5].bnK_SNO < 0 ? 1 : 2,
                });
            }

            // 非固定薪資 匯費
            if (this.nonFixedData.items[6].fee) {
                form.items[1].variableStatements.push({
                    iteM_SNO: REM_FEE_sno,
                    amt: this.nonFixedData.items[6].fee,
                    paY_DAT: this.nonFixedData.items[6].paY_DAT,
                    bnK_SNO: this.nonFixedData.items[6].bnK_SNO,
                    PAY_WAY: this.nonFixedData.items[6].bnK_SNO < 0 ? 1 : 2,
                });
            }

            // null 轉為 0
            form.items.forEach((item, i) => {
                if (form.items[i].amt === null) form.items[i].amt = 0;

                form.items[i].variableStatements.forEach((statement, j) => {
                    if (form.items[i].variableStatements[j].amt === null) {
                        form.items[i].variableStatements[j].amt = 0;
                    }
                });
            });

            return form;
        },

        // 將 api 得到的薪資資料，轉換到 localForm 表單
        apiFormToLocalForm(apiForm, copyLastMonthTab) {
            if (!copyLastMonthTab) {
                this.localForm.year = apiForm.year;
                this.localForm.month = apiForm.month;
            }

            const remFeeSno = this.findItemSnoByNo('REM_FEE');
            // 總計、人數、備註、銀行
            this.setFixedData(apiForm, remFeeSno, copyLastMonthTab);
            this.setNonFixedData(apiForm, remFeeSno, copyLastMonthTab);
            this.setBonusData(apiForm, copyLastMonthTab);
            this.setPersonnelData(apiForm, copyLastMonthTab);

            // 每一個子項目（代扣）
            this.setSubItemData(apiForm, copyLastMonthTab);

            this.updateAmts();
        },

        setFixedData(apiForm, remFeeSno, copyLastMonthTab) {
            if (copyLastMonthTab && !['all', '1'].includes(copyLastMonthTab)) return;

            this.fixedData.items[0].amt = apiForm.items[0].totaL_AMT;
            this.fixedData.items[5].amt = apiForm.items[0].amt;
            if (!copyLastMonthTab) {
                this.fixedData.items[5].paY_DAT = apiForm.items[0].paY_DAT;
            } else {
                this.fixedData.items[5].paY_DAT = Number(moment(apiForm.items[0].paY_DAT).add(1, 'month').format('x'));
            }
            this.fixedData.items[5].bnK_SNO = apiForm.items[0].bnK_SNO;

            this.fixedData.mem = apiForm.items[0].mem;
            this.fixedData.headcount = apiForm.items[0].headcount;

            // 匯費
            const remFeeItem0 = apiForm.items[0].variableStatements.find((x) => x.iteM_SNO === remFeeSno);
            if (remFeeItem0) this.localForm.forms[0].items[5].fee = remFeeItem0.amt;
        },
        setNonFixedData(apiForm, remFeeSno, copyLastMonthTab) {
            if (copyLastMonthTab && !['all', '2'].includes(copyLastMonthTab)) return;

            this.nonFixedData.items[0].amt = apiForm.items[1].totaL_AMT || 0;
            this.nonFixedData.items[6].amt = apiForm.items[1].amt;
            if (!copyLastMonthTab) {
                this.nonFixedData.items[6].paY_DAT = apiForm.items[1].paY_DAT;
            } else {
                this.nonFixedData.items[6].paY_DAT = Number(moment(apiForm.items[1].paY_DAT).add(1, 'month').format('x'));
            }
            this.nonFixedData.items[6].bnK_SNO = apiForm.items[1].bnK_SNO;

            this.nonFixedData.mem = apiForm.items[1].mem;
            this.nonFixedData.headcount = apiForm.items[1].headcount;

            // 匯費
            const remFeeItem1 = apiForm.items[1].variableStatements.find((x) => x.iteM_SNO === remFeeSno);
            if (remFeeItem1) this.localForm.forms[1].items[6].fee = remFeeItem1.amt;
        },
        setBonusData(apiForm, copyLastMonthTab) {
            if (copyLastMonthTab && !['all', '3'].includes(copyLastMonthTab)) return;

            this.bonusData.items[0].amt = apiForm.items[2].totaL_AMT || 0;
            this.bonusData.items[1].amt = apiForm.items[2].totaL_AMT2 || 0;
            this.bonusData.items[4].amt = apiForm.items[2].amt;
            if (!copyLastMonthTab) {
                this.bonusData.items[4].paY_DAT = apiForm.items[2].paY_DAT;
            } else {
                this.bonusData.items[4].paY_DAT = Number(moment(apiForm.items[2].paY_DAT).add(1, 'month').format('x'));
            }
            this.bonusData.items[4].bnK_SNO = apiForm.items[2].bnK_SNO;

            this.bonusData.mem = apiForm.items[2].mem;
            this.bonusData.headcount = apiForm.items[2].headcount;
        },
        setPersonnelData(apiForm, copyLastMonthTab) {
            if (copyLastMonthTab && !['all', '4'].includes(copyLastMonthTab)) return;
            this.personnelData.mem = apiForm.items[3].mem;
        },

        setSubItemData(apiForm, copyLastMonthTab) {
            this.localForm.forms.forEach((form, s) => {
                form.items.forEach((item) => {
                    // 若是複製上個月功能觸發，則僅匯入目前所在頁面資料
                    console.log('copyLastMonthTab', copyLastMonthTab);
                    if (copyLastMonthTab && copyLastMonthTab !== 'all' && copyLastMonthTab !== `${s + 1}`) {
                        return;
                    }

                    const { iteM_SNO: itemSno } = item;

                    // 子項目的 sno 是數字
                    if (Number.isInteger(itemSno)) {
                        // 找到資料中 sno 相同的項目
                        const FOUND = apiForm.items[s].variableStatements.find((x) => x.iteM_SNO === itemSno);
                        if (FOUND) {
                            item.amt = FOUND.amt;
                            if (!copyLastMonthTab) {
                                item.paY_DAT = FOUND.paY_DAT;
                            } else {
                                item.paY_DAT = Number(moment(FOUND.paY_DAT).add(1, 'month').format('x'));
                            }
                            item.bnK_SNO = FOUND.paY_WAY === 1 ? -1 : FOUND.bnK_SNO;
                            item.pamt = FOUND.pamt;

                            if (FOUND.headcount) item.headcount = FOUND.headcount;
                            if (FOUND.payroll) item.payroll = FOUND.payroll;
                        }
                    }
                });
            });
        },

        // 用代號(no)取得代扣項目 sno
        findItemSnoByNo(itemNo) {
            const item = this.withholdingOptions.find((x) => x.iteM_NO === itemNo);
            if (item) return item.sno;
            return null;
        },

        // 自動計算實付薪資金額
        autoActualAmts() {
            // 固定實付薪資 = 月薪資總計 - 代扣稅款 - 代扣勞保 - 代扣健保 - 其他代扣
            const fixedData = _.chain(this.fixedData.items);
            fixedData.find(['id', 'actualAmt']).value().amt = this.getActualTotal(fixedData);

            // 非固定實付薪資 = 月薪資總計 - 代扣稅款 - 代扣勞保 - 代扣健保 - 代扣二代健保 - 其他代扣
            const nonFixedData = _.chain(this.nonFixedData.items);
            nonFixedData.find(['id', 'actualAmt']).value().amt = this.getActualTotal(nonFixedData);

            // 績效獎金實付薪資 = 獎金 + 績效 - 代扣獎金稅款 - 代扣二代健保
            const bonusData = _.chain(this.bonusData.items);
            bonusData.find(['id', 'actualAmt']).value().amt = this.getActualTotal(bonusData);
        },

        // 計算統計金額（for 前端顯示only）
        countTotalsForDisplay() {
            // 薪資總計
            this.total_salary = this.getTotalSalary();

            // 獎金績效
            this.total_bonus = this.getTotalBonus();

            // 代扣合計
            this.total_withholding = this.getWithHolding();

            // 實付金額
            this.total_pay = this.getActualPayTotal();

            // 人事費用
            this.total_fee = this.getFeeTotal();
        },

        setNullToDateBankOnZeroAmt() {
            for (let t = 0; t < 4; t += 1) {
                const tab = this.localForm.forms[t];
                for (let i = 0; i < tab.items.length; i += 1) {
                    const item = tab.items[i];
                    if ((!item.amt || item.amt === 0) && (!item.pamt || item.pamt === 0)) {
                        item.paY_DAT = null;
                        item.bnK_SNO = null;
                    }
                }
            }
        },

        // 計算代扣員工自付額加總（勞保費、健保費）

        // 任一金額輸入框變化
        updateAmts(row) {
            // 付款金額為零時，取消日期、帳戶選項
            this.setNullToDateBankOnZeroAmt();

            // 自動計算：固定、非固定、獎金績效的實付金額（薪資 - 各種代扣）
            this.autoActualAmts();

            // 自動計算：人事費用-勞保費、健保費-員工自付總額（固定代扣勞保＋非固定代扣勞保）
            this.countLOBEmpSelfPayTotal();
            this.countGENEmpSelfPayTotal();

            // 自動計算：人事費用-勞保費、健保費-公司負擔總額（繳款單金額 - 員工自付總額）
            this.countLOBCompanyPayAmt();
            this.countGENCompanyPayAmt();
            this.countRESTCompanyPayAmt();
            this.countGEN2CompanyPayAmt();

            // 顯示統計金額
            this.countTotalsForDisplay();
        },

        // 計算實付薪資（月薪資總計 - 各項代扣）
        getActualTotal(data) {
            const total = data
                .filter((o) => o.id !== 'actualAmt')
                .sumBy((o) => (o.negative ? -(o.amt || 0) : o.amt || 0))
                .value();

            return Number.isNaN(total) ? 0 : total;
        },
        // 自動計算"勞保費-員工自付額"（固定代扣勞保＋非固定代扣勞保）
        countLOBEmpSelfPayTotal() {
            const fixedLOB = _.find(this.fixedData.items, ['id', 'LOB']);
            const nonFixedLOB = _.find(this.nonFixedData.items, ['id', 'LOB']);
            const personnelLOB = _.find(this.personnelData.items, ['id', 'FEE_LOB']);
            personnelLOB.empSelfPay = fixedLOB.amt + nonFixedLOB.amt;
        },
        // 自動計算"健保費-員工自付額"（固定代扣健保＋非固定代扣健保）
        countGENEmpSelfPayTotal() {
            const fixedGEN = _.find(this.fixedData.items, ['id', 'GEN']);
            const nonFixedGEN = _.find(this.nonFixedData.items, ['id', 'GEN']);
            const personnelGEN = _.find(this.personnelData.items, ['id', 'FEE_GEN']);
            personnelGEN.empSelfPay = fixedGEN.amt + nonFixedGEN.amt;
        },
        // 自動計算"勞保費-公司負擔(amt)"（繳款單金額[pamt] - 員工自付額[empSelfPay])
        countLOBCompanyPayAmt() {
            const personnelLOB = _.find(this.personnelData.items, ['id', 'FEE_LOB']);
            personnelLOB.amt = personnelLOB.pamt - personnelLOB.empSelfPay;
        },
        // 自動計算"健保費-公司負擔(amt)"（繳款單金額[pamt] - 員工自付額[empSelfPay])
        countGENCompanyPayAmt() {
            const personnelGEN = _.find(this.personnelData.items, ['id', 'FEE_GEN']);
            personnelGEN.amt = personnelGEN.pamt - personnelGEN.empSelfPay;
        },
        // 自動計算"退休金-公司負擔"（繳款單金額[pamt] ＝ 公司負擔[amt])
        countRESTCompanyPayAmt() {
            const personnelREST = _.find(this.personnelData.items, ['id', 'FEE_REST']);
            personnelREST.amt = personnelREST.pamt;
        },
        // 自動計算"二代健保費-公司負擔"（繳款單金額[pamt] ＝ 公司負擔[amt])
        countGEN2CompanyPayAmt() {
            const personnelGEN2 = _.find(this.personnelData.items, ['id', 'FEE_GEN2']);
            personnelGEN2.amt = personnelGEN2.pamt;
        },
        getLOBTotal() {
            const DATA = _.chain(this.localForm.forms)
                .flatMap((o) => o.items)
                .filter((o) => o.iteM_NO.includes('LOB'));
            const positive = DATA.find(['id', 'FEE_LOB']).value().pamt || 0;
            const negative = DATA.filter((o) => o.negative)
                .sumBy((o) => o.amt || 0)
                .value();
            return positive - negative;
        },
        getGENTotal() {
            const DATA = _.chain(this.localForm.forms)
                .flatMap((o) => o.items)
                .filter((o) => o.iteM_NO.includes('GEN') && !o.iteM_NO.includes('GEN2'));
            const positive = DATA.find(['id', 'FEE_GEN']).value().pamt || 0;
            const negative = DATA.filter((o) => o.negative)
                .sumBy((o) => o.amt || 0)
                .value();
            return positive - negative;
        },
        getTotalSalary() {
            const fixedSalary = _.find(this.fixedData.items, ['id', 'totaL_AMT']).amt || 0;
            const nonFixedSalary = _.find(this.nonFixedData.items, ['id', 'totaL_AMT']).amt || 0;
            return fixedSalary + nonFixedSalary;
        },
        getTotalBonus() {
            return _.chain(this.bonusData.items)
                .filter((o) => o.id.includes('totaL_AMT'))
                .sumBy((o) => o.amt || 0)
                .value();
        },
        getWithHolding() {
            return _.chain(this.localForm.forms)
                .flatMap((o) => o.items)
                .filter((o) => o.negative)
                .sumBy((o) => o.amt || 0)
                .value();
        },
        getActualPayTotal() {
            return _.chain(this.localForm.forms)
                .flatMap((o) => o.items)
                .filter((o) => o.id === 'actualAmt')
                .sumBy((o) => o.amt || 0)
                .value();
        },
        getFeeTotal() {
            return _.sumBy(this.personnelData.items, (o) => o.amt || 0);
        },

        // 日期連動
        onChangeDate() {},

        // 付款帳戶連動
        onChangeBank() {},

        onMoneyInputBlur() {},

        // 將人事薪資-勞保費，繳費日期，同步輸入至固定、非固定的代扣勞保費-繳費日期
        applyPersonnelLOBDateBankToOtherLOBs() {
            const fixedLOB = _.find(this.fixedData.items, ['id', 'LOB']);
            const nonFixedLOB = _.find(this.nonFixedData.items, ['id', 'LOB']);
            const personnelLOB = _.find(this.personnelData.items, ['id', 'FEE_LOB']);

            // 人事薪資-勞保費，有繳款單金額
            if (personnelLOB.pamt > 0) {
                // 固定薪資
                if (fixedLOB.amt) {
                    fixedLOB.paY_DAT = personnelLOB.paY_DAT;
                    fixedLOB.bnK_SNO = personnelLOB.bnK_SNO;
                }
                // 非固定薪資
                if (nonFixedLOB.amt) {
                    nonFixedLOB.paY_DAT = personnelLOB.paY_DAT;
                    nonFixedLOB.bnK_SNO = personnelLOB.bnK_SNO;
                }
            }
        },

        applyPersonnelGENDateBankToOtherGENs() {
            const fixedGEN = _.find(this.fixedData.items, ['id', 'GEN']);
            const nonFixedGEN = _.find(this.nonFixedData.items, ['id', 'GEN']);
            const personnelGEN = _.find(this.personnelData.items, ['id', 'FEE_GEN']);

            // 人事薪資-勞保費，有繳款單金額
            if (personnelGEN.pamt > 0) {
                // 固定薪資
                if (fixedGEN.amt) {
                    fixedGEN.paY_DAT = personnelGEN.paY_DAT;
                    fixedGEN.bnK_SNO = personnelGEN.bnK_SNO;
                }
                // 非固定薪資
                if (nonFixedGEN.amt) {
                    nonFixedGEN.paY_DAT = personnelGEN.paY_DAT;
                    nonFixedGEN.bnK_SNO = personnelGEN.bnK_SNO;
                }
            }
        },

        checkPersonnelLOBpamt() {
            return true;
        },

        checkPersonnelGENpamt() {
            return true;
        },

        // 送出表單
        onSubmit() {
            // 驗證人事費用-
            if (!this.checkPersonnelLOBpamt()) {
                return;
            }

            if (!this.checkPersonnelGENpamt()) {
                return;
            }

            // 將人事薪資-勞保費，繳費日期，同步輸入至固定、非固定的代扣勞保費-繳費日期
            this.applyPersonnelLOBDateBankToOtherLOBs();
            this.applyPersonnelGENDateBankToOtherGENs();

            // 表單驗證
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    // 轉換為 api 格式
                    const form = this.localFormToApiForm(this.localForm);

                    // 新增:0,修改:1 (依網址是否有年份資料判斷)
                    form.typ = this.$route.params.year ? 1 : 0;

                    console.log('upsertSalary', form);

                    this.isSubmitting = true;

                    try {
                        if (form.typ === 0) {
                            await this.$confirm(`您將要新增的是歸屬於 ${this.localForm.year} / ${this.localForm.month} 的人事薪資`, '警告', {
                                confirmButtonText: '確定新增',
                                cancelButtonText: '取消',
                                type: 'warning',
                            });
                        }

                        let skipVocherOperate = false;
                        if (this.companyInfo.isAutoVoucherOn && this.$route.params.year) {
                            const resp = await this.$confirm('是否重新產生本月份薪資的所有傳票？', {
                                confirmButtonText: '是，重新產生所有傳票',
                                cancelButtonText: '否，我自行編輯傳票',
                            })
                                .then(() => true)
                                .catch(() => false);

                            skipVocherOperate = !resp;
                        }

                        await this.$api({
                            url: 'SalaryManagementPage/UpsertSalaryForm',
                            method: 'POST',
                            data: { ...form, skipVocherOperate },
                        });

                        this.$message({
                            showClose: true,
                            type: 'success',
                            message: this.$route.params.year ? '修改成功!' : '新增成功!',
                        });
                        this.$router.push({ name: 'salary' });
                    } finally {
                        this.isSubmitting = false;
                    }
                    return true;
                }

                this.$message({
                    showClose: true,
                    type: 'error',
                    message: '部分資料未填寫，請再檢查。',
                });
                return false;
            });
        },

        // 刪除
        async onDelete() {
            const { year } = this.localForm;
            const { month } = this.localForm;

            try {
                await this.$confirm(`將刪除 ${year}/${month} 人事薪資資料, 是否繼續?`, '警告', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                    type: 'warning',
                });
                await this.$api({
                    url: 'SalaryManagementPage/DeleteSalaryForm',
                    method: 'POST',
                    data: { year, month },
                });
                this.$message({
                    showClose: true,
                    type: 'success',
                    message: '刪除成功!',
                });
                this.$router.push({ name: 'salary' });
            } catch (e) {
                console.log(e);
            }
        },

        async onImportLastMonth() {
            let year = Number(this.localForm.year);
            let month = Number(this.localForm.month) - 1;
            if (month === 0) {
                month = 12;
                year -= 1;
            }
            try {
                await this.$confirm(`確定要複製${year} / ${month}的【${this.currTabName}】資料嗎？`, {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });
                await this.fetchSalaryData(year, month, this.currTab);
                this.updateAmts();
            } catch (e) {
                console.log(e);
            }
        },
        async onImportCommand() {
            let year = Number(this.localForm.year);
            let month = Number(this.localForm.month) - 1;
            if (month === 0) {
                month = 12;
                year -= 1;
            }
            try {
                await this.$confirm(`確定要複製${year} / ${month}的全部資料嗎？`, {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });
                await this.fetchSalaryData(year, month, 'all');
            } catch (e) {
                console.log(e);
            }
        },
        copyLastMonthPersonnel() {
            // 人事費用：退休金
            const personnelREST = _.find(this.personnelData.items, ['id', 'FEE_REST']);
            personnelREST.pamt = this.lastPersonnelInfo.restPamt;
            personnelREST.amt = this.lastPersonnelInfo.restPamt;
            personnelREST.bnK_SNO = this.lastPersonnelInfo.restBnk;
            personnelREST.headcount = this.lastPersonnelInfo.restHeadCount;
            personnelREST.payroll = this.lastPersonnelInfo.restPayRoll;
            if (personnelREST.pamt !== 0) {
                if (personnelREST.bnK_SNO > 0) {
                    personnelREST.paY_WAY = personnelREST.bnK_SNO ? 2 : 1;
                } else {
                    personnelREST.paY_WAY = 1;
                    personnelREST.bnK_SNO = -1;
                }
            }

            if (this.lastPersonnelInfo.restPayDat) {
                personnelREST.paY_DAT = Number(moment(this.lastPersonnelInfo.restPayDat).add(1, 'month').format('x'));
            }

            // 人事費用：勞保
            const personnelLOB = _.find(this.personnelData.items, ['id', 'FEE_LOB']);
            personnelLOB.pamt = this.lastPersonnelInfo.laborPamt; // 繳款單金額
            personnelLOB.bnK_SNO = this.lastPersonnelInfo.laborBnk;
            personnelLOB.payroll = this.lastPersonnelInfo.laborPayRoll;
            personnelLOB.headcount = this.lastPersonnelInfo.laborHeadCount;
            if (personnelLOB.pamt !== 0) {
                if (personnelLOB.bnK_SNO > 0) {
                    personnelLOB.paY_WAY = personnelLOB.bnK_SNO ? 2 : 1;
                } else {
                    personnelLOB.paY_WAY = 1;
                    personnelLOB.bnK_SNO = -1;
                }
            }
            if (this.lastPersonnelInfo.genPayDat) {
                personnelLOB.paY_DAT = Number(moment(this.lastPersonnelInfo.genPayDat).add(1, 'month').format('x'));
            }
            this.countLOBEmpSelfPayTotal();
            this.countLOBCompanyPayAmt();

            // 人事費用：健保
            const personnelGEN = _.find(this.personnelData.items, ['id', 'FEE_GEN']);
            personnelGEN.pamt = this.lastPersonnelInfo.genPamt;
            personnelGEN.bnK_SNO = this.lastPersonnelInfo.genBnk;
            personnelGEN.headcount = this.lastPersonnelInfo.genHeadCount;
            personnelGEN.payroll = this.lastPersonnelInfo.genPayRoll;
            if (personnelGEN.pamt !== 0) {
                if (personnelGEN.bnK_SNO > 0) {
                    personnelGEN.paY_WAY = personnelGEN.bnK_SNO ? 2 : 1;
                } else {
                    personnelGEN.paY_WAY = 1;
                    personnelGEN.bnK_SNO = -1;
                }
            }
            if (this.lastPersonnelInfo.genPayDat) {
                personnelGEN.paY_DAT = Number(moment(this.lastPersonnelInfo.genPayDat).add(1, 'month').format('x'));
            }
            this.countGENEmpSelfPayTotal();
            this.countGENCompanyPayAmt();

            // 人事費用：二代健保
            const personnelGEN2 = _.find(this.personnelData.items, ['id', 'FEE_GEN2']);
            personnelGEN2.pamt = this.lastPersonnelInfo.gen2Pamt;
            personnelGEN2.amt = this.lastPersonnelInfo.gen2Pamt;
            personnelGEN2.bnK_SNO = this.lastPersonnelInfo.gen2Bnk;
            personnelGEN2.headcount = this.lastPersonnelInfo.gen2HeadCount;
            personnelGEN2.payroll = this.lastPersonnelInfo.gen2PayRoll;
            if (personnelGEN2.pamt !== 0) {
                if (personnelGEN2.bnK_SNO > 0) {
                    personnelGEN2.paY_WAY = personnelGEN2.bnK_SNO ? 2 : 1;
                } else {
                    personnelGEN2.paY_WAY = 1;
                    personnelGEN2.bnK_SNO = -1;
                }
            }
            if (this.lastPersonnelInfo.gen2PayDat) {
                personnelGEN2.paY_DAT = Number(moment(this.lastPersonnelInfo.gen2PayDat).add(1, 'month').format('x'));
            }
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.salary-edit-page {
    .panel-body .right {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 20px;
    }
    .ah-statistics-bar {
        margin: 20px 0;
        padding: 0 10px 20px 10px;

        .item {
            position: relative;
            padding: 0 10px;
            border-left: 1px solid #ddd;

            &:first-child {
                border-left: none;
            }

            .inner {
                border: 1px solid transparent;
                padding: 10px 20px;
                border-radius: 10px;
                transition: 0.2s;

                .label {
                    font-size: 11pt;
                }

                .value {
                    color: $main-color;
                }
            }

            &.blur {
                border-left: 1px solid transparent;
            }

            &.highlight {
                border-left: 1px solid transparent;

                .inner {
                    // background-color: #fff3ba88;
                    border: 1px solid #eee;
                    background-color: #fff;
                    box-shadow: 3px 3px 15px rgba(0, 0, 0, 0.1);
                }
            }

            .calc-symbol {
                display: none;
                position: absolute;
                top: 25px;
                left: -11px;
                width: 20px;
                height: 20px;
                border-radius: 15px;

                &.show {
                    display: block;
                }

                &.add {
                    background-color: green;

                    &:before {
                        content: "";
                        position: absolute;
                        top: 9px;
                        left: 5px;
                        width: 10px;
                        height: 2px;
                        background-color: #fff;
                    }

                    &:after {
                        content: "";
                        position: absolute;
                        top: 9px;
                        left: 5px;
                        width: 10px;
                        height: 2px;
                        background-color: #fff;
                        transform: rotate(90deg);
                    }
                }

                &.divide {
                    background-color: red;

                    &:after {
                        content: "";
                        position: absolute;
                        top: 9px;
                        left: 5px;
                        width: 10px;
                        height: 2px;
                        background-color: #fff;
                    }
                }
            }
        }

        &.totals {
            .item {
                .value {
                    font-size: 14pt;
                }

                &.highlight {
                }
            }
        }
    }

    .el-form-item--small.el-form-item {
        margin-bottom: 0;

        &.is-error {
            margin-bottom: 18px;
        }
    }

    .headcount {
        margin: 10px 0 0 0;

        .el-form-item__label {
            text-align: left;
        }

        .input-label {
            font-size: 10.5pt;
            color: #000;
            margin: 0 0 0 1px;
        }
    }

    .edit-tab-bar {
        display: flex;
        justify-content: space-between;
        margin: 15px 0;
        align-items: center;
        padding: 15px 20px 0 20px;
    }

    .section-title {
        color: #463cb2;
        margin: 20px 0 15px 0;
        font-size: 12pt;
        padding: 0 0 10px 0;
        border-bottom: 1px solid #463cb2;
    }

    .bottom-summary {
        display: flex;

        .item {
            flex-grow: 1;

            .label {
                font-size: 10pt;
            }
        }
    }

    .salary-edit-table.el-table {
        td {
            vertical-align: top !important;
        }
        .row-title {
            display: block;
            padding-top: 8px;
            font-size: 10.5pt;
            color: #000;
        }
        .input-under-hint {
            font-size: 8pt;
            color: #8e8bad;
            line-height: 100%;
            padding: 7px 0;
        }
    }
}
</style>
